module.exports = __webpack_public_path__ + "img/warehouse.9b66ae50.svg";